<pre class="language-{{language}} line-numbers">
  <code class="keep-initial-line-feed">{{ code }}</code>
</pre>
